"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.promise");
require("core-js/modules/es6.object.to-string");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.array.find");
const regenerator_1 = __importDefault(require("@babel/runtime/regenerator"));
require("regenerator-runtime/runtime");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try {
    var info = gen[key](arg);
    var value = info.value;
}
catch (error) {
    reject(error);
    return;
} if (info.done) {
    resolve(value);
}
else {
    Promise.resolve(value).then(_next, _throw);
} }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const gatsby_1 = require("gatsby");
const atoms_1 = require("@components/atoms");
const Input_1 = require("@components/atoms/Input");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const AccountPricing_1 = require("@components/molecules/AccountPricing");
const PaymentForm_1 = require("@components/organisms/PaymentForm");
const molecules_1 = require("@components/molecules");
const _utils_1 = require("@utils");
const _theme_1 = require("@theme");
const _store_1 = __importDefault(require("@store"));
const _api_1 = __importDefault(require("@api"));
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const stripe_js_1 = require("@stripe/stripe-js");
var stripePromise = stripe_js_1.loadStripe(process.env.GATSBY_STRIPE_PUBLIC_KEY); // Component
var AccountUpgrade = function AccountUpgrade() {
    var stripe = react_stripe_js_1.useStripe();
    var stripeElements = react_stripe_js_1.useElements();
    var _useGlobal = _store_1.default(function (state) {
        return state.user;
    }, function (actions) {
        return actions.setUser;
    }), user = _useGlobal[0], setUser = _useGlobal[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal2[1];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), setVisibleDropdown = _useGlobal3[1];
    var _React$useState = react_1.default.useState(true), loading = _React$useState[0], setLoading = _React$useState[1];
    var _React$useState2 = react_1.default.useState(user === null || user === void 0 ? void 0 : user.phone), phone = _React$useState2[0], setPhone = _React$useState2[1];
    var _React$useState3 = react_1.default.useState((user === null || user === void 0 ? void 0 : user.tier) === 'digital' ? 'community' : 'bespoke'), tier = _React$useState3[0], setTier = _React$useState3[1];
    var availableTiers = (user === null || user === void 0 ? void 0 : user.tier) === 'digital' ? ['community', 'bespoke'] : ['bespoke'];
    var _React$useState4 = react_1.default.useState(false), modalVisible = _React$useState4[0], setModalVisible = _React$useState4[1];
    var _React$useState5 = react_1.default.useState(false), processing = _React$useState5[0], setProcessing = _React$useState5[1];
    var _useGlobal4 = _store_1.default(function (state) {
        return state.notification;
    }, function (actions) {
        return actions.setNotification;
    }), setNotification = _useGlobal4[1];
    var _React$useState6 = react_1.default.useState(true), recurring = _React$useState6[0], setRecurring = _React$useState6[1];
    var toggleRecurring = function toggleRecurring() {
        return setRecurring(!recurring);
    };
    var _React$useState7 = react_1.default.useState((user === null || user === void 0 ? void 0 : user.firstName) + " " + (user === null || user === void 0 ? void 0 : user.lastName)), nameOnCard = _React$useState7[0], setNameOnCard = _React$useState7[1];
    var _React$useState8 = react_1.default.useState(''), postalCode = _React$useState8[0], setPostalCode = _React$useState8[1];
    var cardNumber = stripeElements === null || stripeElements === void 0 ? void 0 : stripeElements.getElement(react_stripe_js_1.CardNumberElement);
    var _React$useState9 = react_1.default.useState(false), cardNumberValid = _React$useState9[0], setCardNumberValid = _React$useState9[1];
    var _React$useState10 = react_1.default.useState(false), cardExpiresValid = _React$useState10[0], setCardExpiresValid = _React$useState10[1];
    var _React$useState11 = react_1.default.useState(false), cardCvcValid = _React$useState11[0], setCardCvcValid = _React$useState11[1];
    var times = ['9am EST', '10am EST', '11am EST', '12pm EST', '1pm EST', '2pm EST', '3pm EST', '4pm EST', '5pm EST'];
    var dates = [];
    var gsDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var today = new Date();
    for (var i = 1; i <= 7; i++) {
        var nextDate = new Date();
        nextDate.setDate(today.getDate() + i);
        if (nextDate.getDay() > 0 && nextDate.getDay() < 6) {
            // Monday through Friday
            dates.push(gsDayNames[nextDate.getDay()]);
        }
    }
    var _React$useState12 = react_1.default.useState(dates[0]), bespokeCallDate = _React$useState12[0], setBespokeCallDate = _React$useState12[1];
    var _React$useState13 = react_1.default.useState(times[2]), bespokeCallTime = _React$useState13[0], setBespokeCallTime = _React$useState13[1];
    var processWithMethodId = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ regenerator_1.default.mark(function _callee2(paymentMethodId) {
            return regenerator_1.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _api_1.default('createSubscription', {
                                paymentMethodId: paymentMethodId,
                                recurring: recurring,
                                bespokeCallDate: bespokeCallDate,
                                bespokeCallTime: bespokeCallTime,
                                tier: tier,
                                phone: phone,
                                proratedDiscount: proratedDiscount
                            }).then(/*#__PURE__*/ function () {
                                var _ref2 = _asyncToGenerator(/*#__PURE__*/ regenerator_1.default.mark(function _callee(response) {
                                    return regenerator_1.default.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    if (!(response.status !== 204)) {
                                                        _context.next = 2;
                                                        break;
                                                    }
                                                    throw new Error(response.statusText);
                                                case 2:
                                                    setNotification({
                                                        type: 'confirmation',
                                                        title: tier === 'community' ? 'Payment successful' : 'Account created',
                                                        message: tier === 'community' ? "We successfully processed your payment. A receipt has been sent to \u2018" + (user === null || user === void 0 ? void 0 : user.email) + "\u2019." : "We successfully upgraded your PRIOR account."
                                                    });
                                                    _context.next = 5;
                                                    return _api_1.default('syncStripePaymentMethods');
                                                case 5:
                                                    _context.next = 7;
                                                    return _api_1.default('refreshUser').then(function (response) {
                                                        return response.json().then(function (refreshedUser) {
                                                            setUser(refreshedUser);
                                                            setProcessing(false);
                                                            setPanel('upgraded');
                                                        });
                                                    });
                                                case 7:
                                                case "end":
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee);
                                }));
                                return function (_x2) {
                                    return _ref2.apply(this, arguments);
                                };
                            }()).catch(function (e) {
                                setNotification({
                                    type: 'warning',
                                    title: 'Error',
                                    message: e.message
                                });
                                setProcessing(false);
                                throw new Error(e);
                            });
                        case 2:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2);
        }));
        return function processWithMethodId(_x) {
            return _ref.apply(this, arguments);
        };
    }(); // Setup a payment method for future billing, and process.
    // https://stripe.com/docs/payments/save-and-reuse
    var processPayment = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ regenerator_1.default.mark(function _callee3() {
            var _yield$PriorApi$then$, client_secret, _yield$stripe$confirm, error, setupIntent;
            return regenerator_1.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!(!stripe || !stripeElements)) {
                                _context3.next = 2;
                                break;
                            }
                            return _context3.abrupt("return");
                        case 2:
                            setProcessing(true);
                            if (!paymentMethodId) {
                                _context3.next = 8;
                                break;
                            }
                            _context3.next = 6;
                            return processWithMethodId(paymentMethodId);
                        case 6:
                            setProcessing(false);
                            return _context3.abrupt("return");
                        case 8:
                            _context3.next = 10;
                            return _api_1.default('createStripeSetupIntent').then(function (r) {
                                return r.json();
                            }).catch(function (e) {
                                return console.log('client secret missing', e);
                            });
                        case 10:
                            _yield$PriorApi$then$ = _context3.sent;
                            client_secret = _yield$PriorApi$then$.client_secret;
                            _context3.next = 14;
                            return stripe.confirmCardSetup(client_secret, {
                                payment_method: {
                                    card: cardNumber,
                                    /* "Hey where's the expiration date and CVC?"
                                     * Stripe uses 'magic' (it's watching in the iFrames).
                                     */
                                    billing_details: {
                                        name: nameOnCard,
                                        email: user === null || user === void 0 ? void 0 : user.email,
                                        address: {
                                            postal_code: postalCode
                                        }
                                    }
                                }
                            });
                        case 14:
                            _yield$stripe$confirm = _context3.sent;
                            error = _yield$stripe$confirm.error;
                            setupIntent = _yield$stripe$confirm.setupIntent;
                            if (!(error || !setupIntent || !setupIntent.payment_method || setupIntent.status !== 'succeeded')) {
                                _context3.next = 21;
                                break;
                            }
                            setNotification({
                                type: 'warning',
                                title: 'Payment information error',
                                message: error === null || error === void 0 ? void 0 : error.message
                            });
                            setProcessing(false);
                            throw new Error(error === null || error === void 0 ? void 0 : error.message);
                        case 21:
                            _context3.next = 23;
                            return processWithMethodId(setupIntent.payment_method);
                        case 23:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3);
        }));
        return function processPayment() {
            return _ref3.apply(this, arguments);
        };
    }();
    var _React$useState14 = react_1.default.useState(), paymentMethodId = _React$useState14[0], setPaymentMethodId = _React$useState14[1];
    var _React$useState15 = react_1.default.useState(), paymentMethods = _React$useState15[0], setPaymentMethods = _React$useState15[1];
    react_1.default.useEffect(function () {
        _api_1.default('listPaymentMethods').then(function (response) {
            setLoading(false);
            if (response.status !== 200) {
                return;
            }
            response.json().then(function (data) {
                var _data$find;
                setPaymentMethodId((_data$find = data.find(function (a) {
                    return a.default;
                })) === null || _data$find === void 0 ? void 0 : _data$find.id);
                setPaymentMethods(data.length < 1 ? undefined : data.reduce(function (obj, item) {
                    var _Object$assign;
                    return Object.assign({}, obj, (_Object$assign = {}, _Object$assign[item.id] = _utils_1.capitalize(item.brand) + " ending in " + item.last4, _Object$assign));
                }, {}));
            });
        });
    }, []);
    var _React$useState16 = react_1.default.useState(false), formValid = _React$useState16[0], setFormValid = _React$useState16[1];
    react_1.default.useEffect(function () {
        setFormValid(!!paymentMethodId || !!cardNumberValid && !!cardExpiresValid && !!cardCvcValid && !!postalCode && !!nameOnCard);
    }, [paymentMethodId, cardNumberValid, cardExpiresValid, cardCvcValid, postalCode, nameOnCard]); // const proratedDiscount = (user?.tier === 'community') ? undefined
    //   : Date.now() - Date(user?.currentPeriodEnd)
    //   const t = new Date(user?.currentPeriodEnd)
    var proratedDiscount = 0;
    if ((user === null || user === void 0 ? void 0 : user.tier) === 'community' && (user === null || user === void 0 ? void 0 : user.currentPeriodEndTimestamp)) {
        var millisecondsLeftInPlan = (user === null || user === void 0 ? void 0 : user.currentPeriodEndTimestamp) - Date.now();
        var daysLeftInPlan = millisecondsLeftInPlan / (1000 * 60 * 60 * 24);
        var monthsLeftInPlan = Math.floor(daysLeftInPlan / 30);
        proratedDiscount = parseInt(AccountInHeader_1.tiers.find(function (t) {
            return t.name === 'community';
        })['priceInCents']) / (13 - monthsLeftInPlan);
    }
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.BackButton, {
        onClick: function onClick() {
            return setVisibleDropdown(undefined);
        }
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Arrow, null)), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        fullWidth: true,
        shortPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Header, {
        noPadding: true,
        marginBottom: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "left",
        isDrawer: true
    }, "Checkout"), AccountInHeader_1.tiers.filter(function (t) {
        return t.name === tier;
    }).map(function (t) {
        return /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "Upgrade to ", _utils_1.capitalize(t.name));
    }), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Caption, null, "We're excited you're choosing to upgrade your membership with PRIOR, please review the details of your new tier below. If you require additional support, please ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/contact"
    }, "contact us"), "."))), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        shortPadding: true
    }, AccountInHeader_1.tiers.filter(function (t) {
        return t.name === tier;
    }).map(function (t) {
        return /*#__PURE__*/ react_1.default.createElement(TierDescription, {
            key: t.name
        }, /*#__PURE__*/ react_1.default.createElement(AccountPricing_1.ImageWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Image, {
            src: "/images/accounts/" + tier + "Header.png",
            objectFit: "contain"
        })), /*#__PURE__*/ react_1.default.createElement(AccountPricing_1.TierName, null, _utils_1.capitalize(t.name)), /*#__PURE__*/ react_1.default.createElement(AccountPricing_1.List, null, t.features.map(function (feature, i) {
            return /*#__PURE__*/ react_1.default.createElement("li", {
                key: i,
                dangerouslySetInnerHTML: {
                    __html: feature
                }
            });
        })), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Trigger, {
            onClick: function onClick() {
                return setModalVisible(true);
            }
        }, "See The Full List"));
    })), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        shortPadding: true
    }, loading && /*#__PURE__*/ react_1.default.createElement(atoms_1.Spinner, {
        mask: _theme_1.palette.snow
    }), !loading && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement("div", null, /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        name: "tier",
        value: tier,
        label: "Membership Type",
        onChange: function onChange(e) {
            return setTier(e.target.value);
        },
        options: availableTiers,
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "tel",
        value: phone,
        label: "Phone Number",
        name: "phone",
        onChange: setPhone,
        required: true,
        disabled: processing
    })), paymentMethods && /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        name: "paymentMethods",
        value: paymentMethodId,
        options: paymentMethods,
        onChange: function onChange(e) {
            return setPaymentMethodId(e.target.value);
        },
        label: "Payment Method",
        required: true,
        disabled: processing,
        capitalize: false
    })), !paymentMethods && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: nameOnCard,
        label: "Name on card",
        name: "nameOnCard",
        onChange: function onChange(e) {
            return setNameOnCard(e.target.value);
        },
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        required: true,
        label: "Credit Card Number",
        onChange: function onChange(e) {
            return setCardNumberValid(!e.empty && e.complete);
        },
        disabled: processing
    }, /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.CardNumberElement, {
        className: "stripePadding",
        options: {
            style: _theme_1.stripeInputStyle
        }
    }))), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        label: "Expiration Date",
        onChange: function onChange(e) {
            return setCardExpiresValid(!e.empty && e.complete);
        },
        required: true,
        disabled: processing
    }, /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.CardExpiryElement, {
        className: "stripePadding",
        options: {
            style: _theme_1.stripeInputStyle
        }
    })), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        label: "Security Code",
        onChange: function onChange(e) {
            return setCardCvcValid(!e.empty && e.complete);
        },
        required: true,
        disabled: processing
    }, /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.CardCvcElement, {
        className: "stripePadding",
        options: {
            style: _theme_1.stripeInputStyle
        }
    }))), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: postalCode,
        label: "Postal Code",
        name: "postalCode",
        onChange: function onChange(_ref4) {
            var value = _ref4.target.value;
            return setPostalCode(value);
        },
        required: true,
        disabled: processing
    }))), tier === 'bespoke' && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.CaptionSmall, {
        paddingFull: true
    }, "We\u2019d love to chat before processing your application and payment, please select your prefered time and date for a call."), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        value: bespokeCallDate,
        label: "Preferred Day",
        name: "bespokeCallDate",
        onChange: function onChange(e) {
            return setBespokeCallDate(e.target.value);
        },
        options: dates,
        required: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        value: bespokeCallTime,
        label: "Preferred Time",
        name: "bespokeCallTime",
        onChange: function onChange(e) {
            return setBespokeCallTime(e.target.value);
        },
        options: times,
        required: true,
        disabled: processing
    })))), /*#__PURE__*/ react_1.default.createElement("div", null, AccountInHeader_1.tiers.filter(function (t) {
        return t.name === tier;
    }).map(function (t) {
        return /*#__PURE__*/ react_1.default.createElement(PaymentForm_1.CheckoutRowWrapper, {
            key: t.name
        }, proratedDiscount > 0 && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(PaymentForm_1.CheckoutRow, null, /*#__PURE__*/ react_1.default.createElement("dt", null, "subtotal"), /*#__PURE__*/ react_1.default.createElement("dd", null, "$", _utils_1.money(t.priceInCents))), /*#__PURE__*/ react_1.default.createElement(PaymentForm_1.CheckoutRow, null, /*#__PURE__*/ react_1.default.createElement("dt", null, "prorated discount"), /*#__PURE__*/ react_1.default.createElement("dd", null, "$", _utils_1.money(proratedDiscount)))), /*#__PURE__*/ react_1.default.createElement(PaymentForm_1.CheckoutRow, {
            large: true
        }, /*#__PURE__*/ react_1.default.createElement("dt", null, "total"), /*#__PURE__*/ react_1.default.createElement("dd", null, "$", _utils_1.money(t.priceInCents - proratedDiscount), tier === 'bespoke' && '*')), tier === 'bespoke' && /*#__PURE__*/ react_1.default.createElement(PaymentForm_1.CheckoutRow, null, /*#__PURE__*/ react_1.default.createElement("p", null, "*You will not be charged until your application has been approved.")));
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.InputCheckbox, {
        name: "recurring",
        onChange: toggleRecurring,
        checked: recurring,
        outline: true
    }, "I\u2019d like PRIOR to charge my card annually. You will always receive a notification before being charged."), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.ButtonWrapper, {
        shortPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, Object.assign({
        shadow: true,
        size: "large",
        display: "flex",
        disabled: processing || !formValid,
        onClick: function onClick() {
            return processPayment();
        }
    }, {
        processing: processing
    }), tier === 'community' && /*#__PURE__*/ react_1.default.createElement("span", null, "Upgrade Membership"), tier === 'bespoke' && /*#__PURE__*/ react_1.default.createElement("span", null, "Apply to Upgrade")))))), /*#__PURE__*/ react_1.default.createElement(atoms_1.Modal, {
        visible: modalVisible,
        setVisible: setModalVisible
    }, /*#__PURE__*/ react_1.default.createElement(molecules_1.TierComparison, null)));
}; // Supporting Component
var AccountUpgradeWrapper = function AccountUpgradeWrapper() {
    return /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.Elements, {
        stripe: stripePromise,
        options: {
            fonts: [{
                    cssSrc: 'https://fonts.googleapis.com/css?family=Inter:semibold'
                }]
        }
    }, /*#__PURE__*/ react_1.default.createElement(AccountUpgrade, null));
}; // Styling
var TierDescription = styled_components_1.default.div.withConfig({
    displayName: "AccountUpgrade__TierDescription",
    componentId: "uf3mlr-0"
})(["border:1px solid ", ";padding:24px 16px;", "{position:sticky;top:40px;}", "{padding:40px 32px;}", "{padding:48px 40px;}"], _utils_1.rgba(_theme_1.palette.ink, 0.32), _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledLink = styled_components_1.default(gatsby_1.Link).withConfig({
    displayName: "AccountUpgrade__StyledLink",
    componentId: "uf3mlr-1"
})(["color:", ";"], _theme_1.palette.brown);
exports.default = AccountUpgradeWrapper;
